<template>
  <g fill-rule="evenodd">
    <path
      d="M3.77 19h13.46c1.543 0 2.77-1.268 2.77-2.864v-13.5C20 1.736 19.288 1 18.417 1H6.542c-.871 0-1.584.736-1.584 1.636v4.091H2.583C1.713 6.727 1 7.464 1 8.364v7.772C1 17.732 2.227 19 3.77 19z"
    />
    <path
      class="secondary-color"
      d="M18.417 16.136c0 .696-.515 1.228-1.188 1.228H6.265c.198-.369.277-.819.277-1.228v-13.5h11.875v13.5zm-15.834 0V8.364h2.375v7.772c0 .696-.514 1.228-1.187 1.228s-1.188-.532-1.188-1.228z"
    />
    <path
      d="M8.917 9.182h7.125c.435 0 .791-.368.791-.818V5.09c0-.45-.356-.818-.791-.818H8.917c-.436 0-.792.368-.792.818v3.273c0 .45.356.818.792.818z"
    />
    <path class="secondary-color" d="M9.708 7.545h5.542V5.909H9.708z" />
    <path
      d="M8.917 12.455h7.125c.435 0 .791-.369.791-.819 0-.45-.356-.818-.791-.818H8.917c-.436 0-.792.368-.792.818 0 .45.356.819.792.819m0 3.272h4.75c.435 0 .791-.368.791-.818 0-.45-.356-.818-.791-.818h-4.75c-.436 0-.792.368-.792.818 0 .45.356.818.792.818"
    />
  </g>
</template>

<script>
import { defineComponent } from "vue";

export default defineComponent({
  name: "ActionLogsIcon",
});
</script>
